import { render, staticRenderFns } from "./CatalogLinks.vue?vue&type=template&id=ca15582a&scoped=true"
import script from "./CatalogLinks.vue?vue&type=script&lang=ts"
export * from "./CatalogLinks.vue?vue&type=script&lang=ts"
import style0 from "./CatalogLinks.vue?vue&type=style&index=0&id=ca15582a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca15582a",
  null
  
)

export default component.exports